module.exports = __webpack_public_path__ + "img/content.821618ac.png";